<template>
  <Modal
    v-model="show"
    footer-hide
    class-name="cause-selection-modal"
    width="1100"
    :closable="false"
    :mask-closable="false"
  >
    <div class="cause-selection">
      <div class="header">
        <div class="title">
          病因确认
          <!-- <div class="close" @click="cancel">
            <Icon type="md-close-circle" />
          </div> -->
        </div>
        <div class="title-tip">
          单击病因下的常见底层原因进行选择/取消，或输入其他原因
        </div>
      </div>
      <div class="content">
        <div class="g-list">
          <div
            class="g-list-item"
            v-for="group in list.filter((g) => g.isShow)"
            :key="group.value"
          >
            <div class="g-list-title">
              {{ group.label }}
            </div>
            <div class="g-list-body">
              <div class="list">
                <div
                  class="list-item"
                  v-for="item in group.children.filter((i) => i.isShow)"
                  :key="item.value"
                >
                  <div class="name">
                    <span class="point"></span>
                    <span class="name-text" :class="item.label">{{
                      item.label
                    }}</span>
                  </div>
                  <div class="c_list">
                    <div
                      class="c_list_item"
                      v-for="(i_item, i_index) in item.children.filter(
                        (i) => i.isShow
                      )"
                      @click="onClick(i_item, item, i_index)"
                      :key="i_index"
                    >
                      <span
                        class="icon"
                        :class="{ active: i_item.active }"
                      ></span>
                      {{ i_item.label }}
                    </div>
                    <searchInput :info="item" :patientCode="info.patientCode" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="right" v-if="check">
          <div class="title">已选症状病因核查</div>
          <div class="list">
            <div
              class="item"
              v-for="(item, index) in listDialecticForDsIdFilter"
              :key="index"
            >
              <span class="tip success" v-if="item.order">
                <Icon type="md-checkmark-circle" />
                完成:
              </span>
              <span class="tip warning" v-else>
                <Icon type="md-warning" />
                提醒:
              </span>
              <span>
                <span
                  @click="gotu(l_item)"
                  class="pointer"
                  v-for="(l_item, index) in item.labels"
                  :key="index"
                  >【{{ l_item }}】、</span
                >
                病因必选{{ item.code.length ? "其中至少一个" : "" }}</span
              >
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <span>
          <Button
            class="submitBtn"
            type="primary"
            @click="submit"
            :disabled="(isBtnDisabled && check) || !hasCause"
            >确定</Button
          >
        </span>
      </div>
    </div>
  </Modal>
</template>

<script>
import searchInput from "./searchInput.vue";
import { mapGetters } from "vuex";
export default {
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    info: {
      type: Object,
      default: () => {
        return {};
      },
    },
    selectList: {
      type: Array,
      default: () => [],
    },
    isFirstEtiology: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    searchInput,
  },
  computed: {
    ...mapGetters([
      "ABSTRACT_ETIOLOGY",
      "dicts",
      "userSystemConfig",
      "patientCausePool",
      "userInfo",
    ]),
    causePool() {
      return this.patientCausePool[this.info.registerCode] || null;
    },
    hasCause() {
      //有选择过至少一个病因了
      return this.list.some((group) => {
        return group.children.some((item) => {
          return item.children.some((i) => i.active);
        });
      });
    },
    activeIds() {
      return this.list
        .reduce((pre, cur) => {
          return pre.concat(cur.children);
        }, [])
        .filter((i) => i.children.some((j) => j.active))
        .map((i) => i.value);
    },
    isBtnDisabled() {
      return !this.listDialecticForDsId.every((i) => this.checkFun(i.code));
    },
    listDialecticForDsIdFilter() {
      return this.listDialecticForDsId
        .map((i) => {
          i.order = this.checkFun(i.code) ? 1 : 0;
          return i;
        })
        .sort((a, b) => a.order - b.order);
    },
  },
  data() {
    return {
      showCauseInput: false,
      show: false,
      activeItem: {},
      list: [],
      listDialecticForDsId: [],
      check: false,
    };
  },
  methods: {
    open(isCheck) {
      this.check = isCheck;
      if (!this.check) this.show = true;
      return new Promise((resolve, reject) => {
        this.init()
          .then((res) => {
            let flog = false;
            if ((this.check && this.isBtnDisabled) || this.isFirstEtiology) {
              this.show = true;
              flog = true;
            }
            resolve(flog);
          })
          .catch(reject);
      });
    },
    checkFun(code) {
      return code.some((item) => this.activeIds.includes(item));
    },
    getData() {
      return new Promise((resolve, reject) => {
        let keywords = this.selectList.map((i) => i.dsId).join(",");
        if (!keywords) return;
        this.request
          .post("/saasbaihui/listDialecticForDsId", {
            keywords,
          })
          .then((res) => {
            let list = this.common
              .clone(this.dicts.ABSTRACT_ETIOLOGY)
              .map((i) => {
                i.label = i.string2;
                return i;
              });
            this.listDialecticForDsId = res.result.map((i) => {
              i.labels = this.common.valuesToLabels(list, i.code);
              return i;
            });
            resolve(res.result);
          })
          .catch(reject);
      });
    },

    init() {
      this.activeItem = {};
      this.showCauseInput = false;
      this.setList();
      return this.getData();
    },

    setList() {
      let activeItem = null;
      this.list = this.common.clone(this.ABSTRACT_ETIOLOGY);
      this.list.forEach((item) => {
        item.children.forEach((i_item) => {
          this.value.forEach((s_item) => {
            if (s_item.value == i_item.value) {
              s_item.children.forEach((s_children) => {
                let fItem = i_item.children.find(
                  (i) => i.label == s_children.label
                );
                if (!fItem) {
                  s_children.isShow = true;
                  i_item.children.push(s_children);
                } else {
                  fItem.active = true;
                }
                this.updataCausePool(i_item);
              });
              !activeItem && (activeItem = i_item);
            }
          });
        });
      });
    },
    updataCausePool(item) {
      if (!this.causePool) return;
      let nObj = {};
      nObj[item.value] = item.children.filter((i) => i.active);
      let part = Object.assign(this.causePool.part, nObj);

      let obj = {};
      obj[this.info.registerCode] = {
        body: this.causePool.body,
        part,
        symptomId: this.causePool.symptomId,
      };
      this.$store.commit("patientCausePoolAdd", obj);
    },
    causeInputChange(list) {
      this.activeItem.children = list;
    },
    isAcitve(item) {
      return item.children.length > 0 || this.activeItem.value == item.value;
    },
    onClick(item, g_item, index) {
      if (item.isRoot) {
        item.active = !item.active;
      } else {
        g_item.children.splice(index, 1);
      }
    },
    onDblclick(item) {
      item.children = [];
      this.activeItem = {};
      this.showCauseInput = false;
    },
    cancel() {
      this.show = false;
    },
    nextInput() {
      this.$el.querySelector(".submitBtn").focus();
    },
    gotu(item) {
      let node = $(this.$el).find("." + item);
      node.addClass("jzmding");
      setTimeout(function () {
        node.removeClass("jzmding");
      }, 1000);

      // 点击滚动
      var offset = node.position();
      var gListNode = $(this.$el).find(".g-list");
      var h = gListNode.scrollTop() + offset.top - 100;
      gListNode.animate({ scrollTop: h }, 200);
    },

    submit() {
      let arr = [];
      this.list.forEach((item) => {
        item.children.forEach((i_item) => {
          let l2 = i_item.children.filter((j) => j.active);
          if (l2.length > 0) {
            arr.push({
              ...i_item,
              children: l2,
            });
          }
        });
      });

      this.patientCausePoolAdd(arr);
      this.$emit("input", arr);
      this.$emit("change", arr);
      this.cancel();
      if (this.check) {
        // this.$emit("submit", arr);
      }
    },
    patientCausePoolAdd(arr) {
      if (!this.isAll) return;
      let { body, part } = this.common.getCausePoolData([
        {
          etiologyList: arr,
        },
      ]);

      let symptomId = this.userInfo.husDoctorId;
      if (this.causePool) {
        let item = this.selectList.find(
          (item) => item.value == this.causePool.symptomId
        );
        if (item) {
          symptomId = this.causePool.symptomId;
        }
      }

      let obj = {};
      obj[this.info.registerCode] = {
        body,
        part,
        symptomId,
      };
      this.$store.commit("patientCausePoolAdd", obj);
    },
  },
};
</script>

<style lang="scss" >
.cause-selection-modal {
  display: flex;
  align-items: center;
  justify-content: center;

  .ivu-modal {
    top: 30px;
  }

  .ivu-modal-body {
    padding: 0px;
  }
  .cause-selection {
    padding: 0;
    width: 100%;
    height: 100%;
    color: #222;
    display: flex;
    flex-direction: column;
    background: #fff;
    .header {
      padding: 10px 15px;
      border-bottom: 1px solid #ddd;
    }
    .content {
      height: 80vh;
      display: flex;
      .right {
        height: 100%;
        width: 260px;
        flex-shrink: 0;
        border-left: 1px solid #ccc;
        padding: 15px;
        display: flex;
        flex-direction: column;
        .list {
          height: 100%;
          overflow-y: auto;
        }
        .warning {
          color: #ce5f0f;
        }
        .success {
          color: green;
        }
        .item {
          margin: 0 0 10px 25px;
        }
        .tip {
          position: relative;
          .ivu-icon {
            position: absolute;
            left: -25px;
            top: -2px;
            font-size: 18px;
          }
        }
      }
    }
    .g-list {
      height: 100%;
      overflow-y: auto;
      padding: 0 15px;
    }
    .footer {
      text-align: center;
      border-top: 1px solid #ddd;
      padding: 10px 15px;
      .ivu-btn {
        width: 140px;
        & + .ivu-btn {
          margin-left: 10px;
        }
      }
    }
    .vertical-center-modal {
      display: flex;
      align-items: center;
      justify-content: center;

      .ivu-modal {
        top: 0;
      }
    }

    .g-list {
      width: 100%;
    }

    .g-list-item {
      margin-bottom: 10px;
      .g-list-title {
        font-weight: bold;
        line-height: 2em;
        padding-bottom: 5px;
        & > span {
          font-size: 12px;
        }
      }
    }
  }
  .title {
    font-weight: bold;
    padding-bottom: 5px;
    position: relative;
    span {
      color: #853a2f;
    }
    .close {
      position: absolute;
      right: 0;
      top: 0;
      font-size: 26px;
      line-height: 26px;
      color: #853a2f;
      cursor: pointer;
    }
  }
  .title-tip {
    font-size: 12px;
    color: #666;
  }
  .list {
    width: 100%;
    .list-item {
      margin-bottom: 8px;
      .icon {
        flex-shrink: 0;
        display: inline-block;
        width: 20px;
        height: 20px;
        background: #f3e6d5;
        border-radius: 100%;
        margin-right: 5px;
        &.active {
          background: #853a2f;
        }
      }
      .name {
        padding: 0 0 10px;
        display: flex;
        align-items: center;
        .point {
          position: relative;
          width: 15px;
          height: 21px;
          display: inline-block;
          &::before {
            content: " ";
            position: absolute;
            top: 8px;
            left: 0;
            width: 5px;
            height: 5px;
            border-radius: 1px;
            background: #853a2f;
          }
        }
      }
      .c_list {
        display: flex;
        flex-wrap: wrap;
        .c_list_item {
          width: 18%;
          margin-right: 15px;
          display: flex;
          align-items: center;
          font-size: 13px;
          color: #853a2f;
          margin-bottom: 10px;
          position: relative;
          cursor: pointer;
          .ivu-input-wrapper {
            margin-bottom: 0;
          }
          &.input-mk,
          .ivu-tooltip-rel {
            display: flex;
            align-items: center;
          }
          .ivu-tooltip-inner {
            width: 150px;
            white-space: inherit;
          }
        }
      }
    }
  }
  .disabled {
    .list .list-item .icon {
      width: 5px;
      height: 5px;
    }
    .list .list-item .c_list .c_list_item {
      cursor: not-allowed;
    }
  }
  .submitBtn {
    &:focus {
      background: rgba(230, 46, 46, 0.8);
    }
  }
  .pointer {
    cursor: pointer;
  }
  .name-text {
    display: inline-block;
    &.jzmding {
      background: #ce5f0f;
      color: #fff;
      border-radius: 3px;
      padding: 0 5px;
    }
  }
}
</style>